import {Filter} from './filters/filter-block/filter-item/filter';
import {FilterBlock} from './filters/filter-block/filter-block';

export class FilterSearch {

  field: string;
  value: string;
  skip: boolean = false;
  range: boolean = false;

  rangeFrom: number;
  rangeTo: number;

  selected: boolean = true;
  excluded: boolean = false;
  or: boolean = false;

  hideInResult = false;
  childFacetList: any[];
  childFilterBlocks: FilterBlock[];


  constructor(attr: { childFilterBlocks?: FilterBlock[], childFacetList?: any[], field?: string, value?: string, selected?: boolean, excluded?: boolean, or?: boolean, skip?: boolean, range?: boolean, rangeFrom?: number, rangeTo?: number, hideInResult?: boolean } = {}) {
    this.update(attr);
  }

  update(attr: { childFilterBlocks?: FilterBlock[], childFacetList?: any[], field?: string, value?: string, selected?: boolean, excluded?: boolean, or?: boolean, skip?: boolean, range?: boolean, rangeFrom?: number, rangeTo?: number, hideInResult?: boolean } = {}) {
    this.field = attr.field;
    this.value = attr.value;
    if(attr.childFacetList) {
      this.childFacetList = attr.childFacetList.map(filter => {
        return new Filter(filter);
      });
    };
    if (attr.value == undefined) this.value = "";
    if (attr.value === null) this.value = "";
    this.skip = attr.skip;
    this.selected = attr.selected;
    this.excluded = attr.excluded;
    this.or = attr.or;
    this.range = attr.range;
    this.rangeFrom = attr.rangeFrom;
    this.rangeTo = attr.rangeTo;
    this.hideInResult = attr.hideInResult;
  }

  toURL(): string {
    if (this.range) {
      return `>${this.field}:${this.getSafeValue()}`;
    } else if (this.skip) {
      return `-${this.field}:${this.getSafeValue()}`;
    } else if (this.excluded) {
      return `${this.field}:!${this.getSafeValue()}`;
    } else if (this.or) {
      return `${this.field}:-${this.getSafeValue()}`;
    } else {
      return `${this.field}:${this.getSafeValue()}`;
    }
  }

  getSafeValue() {
    let txt = this.value;
    if (txt) {
      txt = txt.replace('`', '');
    }

    if (/[-!;:,%'"?\/]/g.test(txt)) {
      return '`' + `${txt}` + '`';
    } else {
      return txt;
    }
  }

  getUrlLength(){
    return encodeURIComponent(this.toURL()).length;
  }

}
